var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "naked-pet-food-1147.myshopify.com",
        "incentive": {
            "type": "fixed_amount",
            "value": "5.00",
            "price_rule_id": 1383950025000,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "OTY5MDM="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Free Coupon",
            "refer_background_color": "#72a441",
            "refer_text_color": "#ffffff",
            "web_position": "right-bottom",
            "mobile_position": "right-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "INVITE YOUR FRIENDS & FAMILY WITH A $5 OFF COUPON",
            "popup_description": "Send your friends & family a $5.00 OFF coupon. Once they make a purchase, you receive reward earnings toward your next Charlie\u2019s Doggie Bag purchase. Charlie Approved.",
            "button_text_get_invite": "Send link",
            "button_copy_invite": "Copy link",
            "popup_background_color": "#72a441",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You've received $5.00 Off",
            "shop_description": "Congratulations! Your friend has gifted you a coupon. Your coupon will be automatically applied when you checkout. Charlie Approved.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#72a441",
            "shop_text_color": "#ffffff"
        }
    }
}